module.exports = __webpack_public_path__ + "img/17_44.4088983e.png";